
define('text!modules/admin/templates/tabs.html',[],function () { return '<div class="w-box w-Admin">\n  <div class="w-head">\n    {{>header}}\n  </div>\n  <div class="w-body">\n    <div class="admin-tabs" data-bind="ignore"></div>\n  </div>\n</div>\n';});

